import {
  businessDescriptionColumnDefinition,
  businessUnitColumnDefinition,
  companyCodeColumnDefinition,
  companyCodeDescriptionColumnDefinition,
  connectionNameColumnDefinition,
  countryNameColumnDefinition,
  legalEntityColumnDefinition,
  selectRowCheckboxColumnDefinition,
} from '../../../shared/columnDefinitions';

const columnDefinitions = [
  selectRowCheckboxColumnDefinition,
  { ...companyCodeColumnDefinition, field: 'cc' },
  { ...companyCodeDescriptionColumnDefinition, field: 'desc' },
  { ...legalEntityColumnDefinition },
  { ...connectionNameColumnDefinition, field: 'connection' },
  { ...countryNameColumnDefinition, field: 'country' },
  { ...businessUnitColumnDefinition },
  { ...businessDescriptionColumnDefinition, field: 'businessDesc' },
];


export default columnDefinitions;
